
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as search40azIuQO_45V5O416T2UUEtXxMQd2LugEuEKr9RgZDQWkMeta } from "/opt/build/repo/pages/search.vue?macro=true";
import { default as referralFxZZ1jMx3tmxB4KD4dEgwkDmDh_4567CzN_2ugbKUS_45uYMeta } from "/opt/build/repo/pages/referral.vue?macro=true";
import { default as settingsYa9S1YcDD9UMaj5ELJs67gQjD0lYJ2UoIw9mzh67w2cMeta } from "/opt/build/repo/pages/settings.vue?macro=true";
import { default as admin3L0aV2FzGUvIgrWkc_vyHg6L0wJioJR1JrK4yR2tqOcMeta } from "/opt/build/repo/pages/webviews/groups/[id]/admin.vue?macro=true";
import { default as indexT2LmZiE2dB2Tv2OxGPm8MabD3N1QwFC0bR2gK8bEacUMeta } from "/opt/build/repo/pages/webviews/groups/[id]/index.vue?macro=true";
import { default as shareMW4S5dwTY9X5SJUuveEya_pkfGlbyyc8rDRQr5e4NEQMeta } from "/opt/build/repo/pages/webviews/groups/[id]/share.vue?macro=true";
import { default as statsyA6_lcdy1yAbvLW_Zv_45Cw1Aq0gQaFll5I7FAXBnavYUMeta } from "/opt/build/repo/pages/webviews/groups/[id]/stats.vue?macro=true";
import { default as memberspk9w_45p_45MbWBXdgxzioMMqRPPNuIWi_B17Bw1ZGK9k94Meta } from "/opt/build/repo/pages/webviews/groups/[id]/members.vue?macro=true";
import { default as indexgGbM9tE1s_45IjdOcvCgEewCrwl0j8_Ro33jv2AWTeRYgMeta } from "/opt/build/repo/pages/webviews/groups/[id]/posts/index.vue?macro=true";
import { default as _91postId_9382yM652awKlOVnb_45i_PELBL2YNyDikC3giZxpOrZtT8Meta } from "/opt/build/repo/pages/webviews/groups/[id]/posts/[postId].vue?macro=true";
import { default as _91id_93kR9PFFVB350l_45TM_451wH5dHXZCS7YbQZB0e_452WKm0J7QMeta } from "/opt/build/repo/pages/webviews/groups/[id].vue?macro=true";
import { default as index_45ZTTVrRfOg4vXR15O13zal_45yXMiulsW5t3CS32Md4wUMeta } from "/opt/build/repo/pages/webviews/groups/index.vue?macro=true";
import { default as searchxCpL7apWqsl6aCXeto93mq_nZZ40b_45zYDh_D6Gg7efIMeta } from "/opt/build/repo/pages/webviews/groups/search.vue?macro=true";
import { default as groupsbH3NeRYdxElGdBW0booMFIhfGc65CrwbJWpxrnJ_45weoMeta } from "/opt/build/repo/pages/webviews/groups.vue?macro=true";
import { default as rankingsqP6lpk3Jy6WFbkTirK2_45oTQoZ8vGLkzRF1gt347jRkAMeta } from "/opt/build/repo/pages/webviews/challenges/[id]/rankings.vue?macro=true";
import { default as _91id_93mRPYmzSE_45oXG0kMKsexPcZSRv1gee59oRJrAaAkWuYoMeta } from "/opt/build/repo/pages/webviews/challenges/[id].vue?macro=true";
import { default as indexNuqrJUlM1HQc8_DJFHk_45syD09zKXE_45tAfGHonjZT2MoMeta } from "/opt/build/repo/pages/webviews/bonus-club/index.vue?macro=true";
import { default as webviews3e6c65rRz23KsB85T5nQgiYmDE0Tr3QellsStpGzevIMeta } from "/opt/build/repo/pages/webviews.vue?macro=true";
import { default as indexZxReMgQKcLQzvh7hRk_45FUHdvASCsiMOPa9AoMnyrJnoMeta } from "/opt/build/repo/pages/user/[id]/index.vue?macro=true";
import { default as photosD65GppMC1gXZ4HK_45CMcMpUktCpeVfAXt1ewSJWCaW9QMeta } from "/opt/build/repo/pages/user/[id]/photos.vue?macro=true";
import { default as blockedW3njopTlqHr3TkmS92DAsTSgoQIKtJMUAqOtiDN2UfwMeta } from "/opt/build/repo/pages/user/[id]/blocked.vue?macro=true";
import { default as followersLmgdXUb8820ZeJc3TECVw4_N_0ac4URa_0zWed2hSh8Meta } from "/opt/build/repo/pages/user/[id]/followers.vue?macro=true";
import { default as followingoYuDgm2wSAtmJyb1rt98KUH5cB5Zy9kRyO_45OodtyDToMeta } from "/opt/build/repo/pages/user/[id]/following.vue?macro=true";
import { default as indexCvKEGBcvSWyX93HRcnaDd0O4o_pRYTwnQXvp2z4zC_8Meta } from "/opt/build/repo/pages/user/[id]/garage/index.vue?macro=true";
import { default as indexRPRzNan_458vsQ8ssAkJnSG5uQGbseCb0sxLxfJbTz7JAMeta } from "/opt/build/repo/pages/user/[id]/groups/index.vue?macro=true";
import { default as newXkD_J2KFvnP1Kw1J4ofNK1REFqhtyFU0hnWa3Lc6vLwMeta } from "/opt/build/repo/pages/user/[id]/getaways/index/new.vue?macro=true";
import { default as indexGtnscud6O5Al1B5i3PNmBYEfJQFRlAxu_P__45wP1MNGcMeta } from "/opt/build/repo/pages/user/[id]/getaways/index.vue?macro=true";
import { default as indexa_FTM91lhEf6AfCvZwL1VCvO3UaIS4_45OQnyQraL_oBQMeta } from "/opt/build/repo/pages/user/[id]/roadbook/index/index.vue?macro=true";
import { default as trips_450aZlnrQT9ayoJPpLx5oswqNPBtB4iTbfHABhZ_45DC84Meta } from "/opt/build/repo/pages/user/[id]/roadbook/index/trips.vue?macro=true";
import { default as plannedmRmB6XpXb4LZpfhFL0l4yfYIOTtfwYmpYf7MaX40IjQMeta } from "/opt/build/repo/pages/user/[id]/roadbook/index/planned.vue?macro=true";
import { default as sectionsvJpmhf4olEEdfw_CQtqbHFA1UsJqq1giGhmBmZgYc2cMeta } from "/opt/build/repo/pages/user/[id]/roadbook/index/sections.vue?macro=true";
import { default as indexVE5_45t0PJA_aQBLPxptaqiVYQTdvxRl14mdnUSSb6O3sMeta } from "/opt/build/repo/pages/user/[id]/roadbook/index.vue?macro=true";
import { default as edito4T_45du8be4kudj2Y64dcfoqQnI4_45s8l5ouJpvhijMmcMeta } from "/opt/build/repo/pages/user/[id]/timeline/index/edit.vue?macro=true";
import { default as indexp_VoHH8E3c46kv5aKUQ0DUsU2Lsl1XtH9iZJuzWDvjUMeta } from "/opt/build/repo/pages/user/[id]/timeline/index.vue?macro=true";
import { default as follow_45requestspxrbZ9v4ALH6_3NWK3gIQ3JcLhq_m8oYjgzBSgqtaZ4Meta } from "/opt/build/repo/pages/user/[id]/follow-requests.vue?macro=true";
import { default as _91achievementID_933cu45U8fiCQNCE0iObDy87XiaXNo7UHKuZZreaeq5KIMeta } from "/opt/build/repo/pages/user/[id]/achievements/index/[achievementID].vue?macro=true";
import { default as index1vFuWoxw2Z4HvGLHmw6it_45SAAf4uJeGbnQv3hfNnIjIMeta } from "/opt/build/repo/pages/user/[id]/achievements/index.vue?macro=true";
import { default as newTjeoWnEhzWTlDKJ_LQN8n_CBDPJFICaKDnEGemMmbCcMeta } from "/opt/build/repo/pages/user/[id]/garage/bikes/index/new.vue?macro=true";
import { default as indexmb48iE9P4WA4B_fONTz47kGmilNW4unOyj6Rgr_45A3tYMeta } from "/opt/build/repo/pages/user/[id]/garage/bikes/index.vue?macro=true";
import { default as newL00tlXXJlC8RjHm78sbY3H6elOD2mfh19JxGC4IvQBAMeta } from "/opt/build/repo/pages/user/[id]/garage/helmets/index/new.vue?macro=true";
import { default as indexGxJuGu321WY9Eoi_GIlLtEyDclO5oJtzRT1eVMHQeMIMeta } from "/opt/build/repo/pages/user/[id]/garage/helmets/index.vue?macro=true";
import { default as newjOPHpEciGvvsiMs3f0gp4yT9Ugw2mJHxvzcIWrSHBwQMeta } from "/opt/build/repo/pages/user/[id]/garage/intercoms/index/new.vue?macro=true";
import { default as indexrFOrFhLU5l_zwbekvhIqI_45TxUbp_453VA77lHMoolAIq4Meta } from "/opt/build/repo/pages/user/[id]/garage/intercoms/index.vue?macro=true";
import { default as _91id_930PY3yfhGcnlHRRutsbxWXx7q8_45WR2ze8QJCOZiQ6GckMeta } from "/opt/build/repo/pages/user/[id].vue?macro=true";
import { default as index27MS6wDo9deSN_KwrCMu_45ggGUoU4zXsfrJ576xKgvm8Meta } from "/opt/build/repo/pages/feed/index.vue?macro=true";
import { default as emailCnZ_45nHJ2Mj4SbbQ4UyGtbuGYd1h5fvxzIuhLvwTmIhcMeta } from "/opt/build/repo/pages/getstarted/email.vue?macro=true";
import { default as indexbNt3Pu5gxfcOz0lqq_YSp6nDMhBoZUf_L2YnmZSNJaQMeta } from "/opt/build/repo/pages/getstarted/index.vue?macro=true";
import { default as google3acR_v_45OB8fOghAJNqdmoXBtmXBZymqhi4X_nAdGD4EMeta } from "/opt/build/repo/pages/getstarted/google.vue?macro=true";
import { default as onboardingxCpjxPsCtT6StgwdqzokmnZqxyb6z1HpaxNg3QYaPfoMeta } from "/opt/build/repo/pages/getstarted/onboarding.vue?macro=true";
import { default as forgot_45passwordeY_459J2DXaeQEasbo7xQaF2MmM0frTm_tsrMJfDICjq8Meta } from "/opt/build/repo/pages/getstarted/forgot-password.vue?macro=true";
import { default as complete_45profilebHiI2q0PsBY_45Hr4Xc7cL1v78cxXzsqR_66a1HW4oClIMeta } from "/opt/build/repo/pages/getstarted/complete-profile.vue?macro=true";
import { default as getstartedfIUuxqZxfRCgjINwl9Nsdbqv_45hUGG0Dvlw5DBehjwz4Meta } from "/opt/build/repo/pages/getstarted.vue?macro=true";
import { default as _91code_93vXoE22mu3C1NC9iap6YdoBd4NQlkwrEqbaG3C02GiaEMeta } from "/opt/build/repo/pages/pro/[code].vue?macro=true";
import { default as editfVrDOqzrySMjvpUy7D_P5edXVIPRsY3Iirpw80_IPrUMeta } from "/opt/build/repo/pages/trips/[id]/edit.vue?macro=true";
import { default as sharevMjREfMTCYsWFwsMWCqKTQn2_DAqQ_45dzjfrTNOubkd8Meta } from "/opt/build/repo/pages/trips/[id]/share.vue?macro=true";
import { default as photos_VtpReyg66tYGRgu_45Hz4LoTypP3RbDl4ylR1yD77xz0Meta } from "/opt/build/repo/pages/trips/[id]/photos.vue?macro=true";
import { default as participantsRU9iu4IYUXLZG75mDlXFYdPzw42JENo7ywPgwiOuCtgMeta } from "/opt/build/repo/pages/trips/[id]/participants.vue?macro=true";
import { default as rewind_45video2R5fO3LyqxaJhQZ29Ggwy4OcmLWMPZbZ4FhKTC95lF0Meta } from "/opt/build/repo/pages/trips/[id]/rewind-video.vue?macro=true";
import { default as _91id_93_HbXxrP8n4dMR4BW94Pc6Oix70C74dEk_LCSFnGRMMoMeta } from "/opt/build/repo/pages/trips/[id].vue?macro=true";
import { default as indexHYeNxlBmuuNw6WlO4fVyq0aF1YM4RT9DrEpitwg78gMMeta } from "/opt/build/repo/pages/user/index.vue?macro=true";
import { default as adminCyViuFW_45fFvOtFrbn7i85p8LnFKnM792vNtMuRwkgHkMeta } from "/opt/build/repo/pages/groups/[id]/admin.vue?macro=true";
import { default as indexIg3Kpx_45cusbR8ojziPuRoq8o9wNeNKjZaw1juPR12yEMeta } from "/opt/build/repo/pages/groups/[id]/index.vue?macro=true";
import { default as statsroUNsvZQJe9DvfObqI0Xvk5twIuVyYHP1DxTeAuuS7YMeta } from "/opt/build/repo/pages/groups/[id]/stats.vue?macro=true";
import { default as tripsQhLJmG_xv8sXiAXnMwWSNNIVmaGuLEw80welNooAq2kMeta } from "/opt/build/repo/pages/groups/[id]/trips.vue?macro=true";
import { default as membersjsPhR0kKgaiviRCZAbXlIrlHapoq6QIKR5XVTwS5X8YMeta } from "/opt/build/repo/pages/groups/[id]/members.vue?macro=true";
import { default as indexpJysVsp2S_Ho39f0zZFdQNuguAyTfzDs9m5H1aKpX28Meta } from "/opt/build/repo/pages/groups/[id]/posts/index.vue?macro=true";
import { default as _91postId_93b56lhhl6Cin_45vNDKIECfRhHgx2xlOzNguJEl_45AjSrIsMeta } from "/opt/build/repo/pages/groups/[id]/posts/[postId].vue?macro=true";
import { default as _91id_93wLna3G_45SbajrwdB2bVOVWuqeOehy1m4FHRAduUy0AXwMeta } from "/opt/build/repo/pages/groups/[id].vue?macro=true";
import { default as sentry_45test__45m9e5Ww7tRc2sH8srttbrAeJ1Rso0Q_XI1d_wwHlqMMeta } from "/opt/build/repo/pages/sentry-test.vue?macro=true";
import { default as bikesI_45wpzQKid0UBH0rCKgkKy00v6QF5pJljLK6fK7AXUF4Meta } from "/opt/build/repo/pages/garage/bikes.vue?macro=true";
import { default as indextB_45FjqQRaUP__45dHnSDDAXwEKCYckUK79_zIjWu_y3_45cMeta } from "/opt/build/repo/pages/garage/index.vue?macro=true";
import { default as newtB1EMCmipqkGOL4la3c7a_nsan7NG3aWtR_45rXkRsZPgMeta } from "/opt/build/repo/pages/groups/index/new.vue?macro=true";
import { default as indexlkmxkwXzk502TPlVqcoFJyAEC1SdVwQa6zwY66V8hBcMeta } from "/opt/build/repo/pages/groups/index.vue?macro=true";
import { default as index5CeMlm7Zv0Gmaz2jg7_6Z8EbzZ507gF_CfS5WsiMwt0Meta } from "/opt/build/repo/pages/getaways/[id]/index.vue?macro=true";
import { default as editbX4J9UBuU4bFCitsOKHrgI249Z5JvFKbnQWWG5LdHQkMeta } from "/opt/build/repo/pages/getaways/[id]/details/edit.vue?macro=true";
import { default as inviteMnaCfC0Ve4QBNcXorRwISHJWThvdCb5_45jyXANDoTwXsMeta } from "/opt/build/repo/pages/getaways/[id]/details/invite.vue?macro=true";
import { default as detailsp_UcYJIBIdpXpODlg9FItazt5prPS7X_el5FhD2tdcsMeta } from "/opt/build/repo/pages/getaways/[id]/details.vue?macro=true";
import { default as membersYOQwkhRJlg3ASoDIlYH2_zT09zuWkUfdk5cqahfr7AIMeta } from "/opt/build/repo/pages/getaways/[id]/members.vue?macro=true";
import { default as commentsTc_45HjWQ5TEub_45Ts9hYqeeTfJje_zlmEqFVAvq7jU5skMeta } from "/opt/build/repo/pages/getaways/[id]/comments.vue?macro=true";
import { default as _91id_93tella6_M5NXkkGpZXk0CWwd5bdO4j0TZTGxL8Sa4PesMeta } from "/opt/build/repo/pages/getaways/[id].vue?macro=true";
import { default as report9mYoVgXid5Jsl0zAcFNGbV7u_458IsdfIY5qHph2NQDOMMeta } from "/opt/build/repo/pages/postings/[id]/report.vue?macro=true";
import { default as reportLaPmnEvsE9LOT_AjQA8rFeq6wP3IJ01IMQ7O2QcTGgkMeta } from "/opt/build/repo/pages/postings/[id]/comments/[comment_id]/report.vue?macro=true";
import { default as _91id_93rnFA45yUjj17KvSKPUdExtmvq4p3IJ8Jv8WWLZkGNPcMeta } from "/opt/build/repo/pages/postings/[id].vue?macro=true";
import { default as _91id_93lUD_45qxQOIrIKCtFjMKI1eK9784bwLpBEukxfRj9bLQUMeta } from "/opt/build/repo/pages/sections/[id].vue?macro=true";
import { default as rewind_45j3Ny_45vsC28rswvbhH5YzfP9r9tN_45AC_IO6s2VQZ1wsMeta } from "/opt/build/repo/pages/t/[id]/rewind.vue?macro=true";
import { default as indexMbHAtJ5Ql0WYvcFssfe12hzXsWpUjPJh4nFxfw0l62kMeta } from "/opt/build/repo/pages/upgrade/index.vue?macro=true";
import { default as _91id_930DAtWbts3C4NTFRouWhJCoj1JgxfrNkHPO3cZb1_45okcMeta } from "/opt/build/repo/pages/challenge/[id].vue?macro=true";
import { default as helmetsYr5ZwMsHL1eI32n3ozxG3XpQJWSK6q5i_Q6TUB4JE1kMeta } from "/opt/build/repo/pages/garage/helmets.vue?macro=true";
import { default as _91code_93JeVe4C8JGQXm7txYoVn1IxV13aXVY1Et_WrJn940_oYMeta } from "/opt/build/repo/pages/voucher/[code].vue?macro=true";
import { default as indexcArVIznXQSCqRSahU4ePaAn4ykni6rtVD72e7XFsXPgMeta } from "/opt/build/repo/pages/bonusclub/index.vue?macro=true";
import { default as discover9XUi13qvBKSKtM2nvMP3hVuRF2Yh_45FMO6_4584Iu_R1a0Meta } from "/opt/build/repo/pages/groups/discover.vue?macro=true";
import { default as successcFZiG6D4gYzN2oT1xbVlq0_7rIT_45itqfchLW_mbYdQkMeta } from "/opt/build/repo/pages/upgrade/success.vue?macro=true";
import { default as edittngaiKCLxt9G0hSucWMsrDTuvHbe_cmd3z9_45wxV8f28Meta } from "/opt/build/repo/pages/bikes/[id]/index/edit.vue?macro=true";
import { default as serviceuHKGNlQdO4dS3i8_W_AI3_JYT9kmZ5FWG7SK4TcdRrEMeta } from "/opt/build/repo/pages/bikes/[id]/index/service.vue?macro=true";
import { default as index4ZX8t40opQJhAZXF5VY3QmLPnx5WIZIyaGbIi9O5_45AQMeta } from "/opt/build/repo/pages/bikes/[id]/index.vue?macro=true";
import { default as past3ArSTS1ASFMBe_APKRcT_1_2Ieqf2w5bkm9lF_45GEqGkMeta } from "/opt/build/repo/pages/challenges/index/past.vue?macro=true";
import { default as currentV5Jnv2Bydt0hULtOSpI8pDgeKGOr0LdmJePfkQWCxYsMeta } from "/opt/build/repo/pages/challenges/index/current.vue?macro=true";
import { default as upcomingPrg1N562uSB0idQjUM0lm1paBypoXsClVw_FVLylrOMMeta } from "/opt/build/repo/pages/challenges/index/upcoming.vue?macro=true";
import { default as indexNmbYAUb0qnynAMnTt2Dfo4J8YkisMZURbLNl9OSl6s8Meta } from "/opt/build/repo/pages/challenges/index.vue?macro=true";
import { default as intercoms_RUpngOox2KdGYcHZCv3lho4mANjeIXgDDQQiHVaj8AMeta } from "/opt/build/repo/pages/garage/intercoms.vue?macro=true";
import { default as weekTT2URtuTYj3WNpTpq_45h_kYXIAA4kvevZZ23O3teIZSQMeta } from "/opt/build/repo/pages/statistics/index/week.vue?macro=true";
import { default as yeart_45HubzeV0y1HVbeTI7UTovRCPb5tBDz7AplaOGorKTQMeta } from "/opt/build/repo/pages/statistics/index/year.vue?macro=true";
import { default as monthLUgStH4Y0dUDqs4s5icl4bJpF3MVxoQvTyfdROmcww4Meta } from "/opt/build/repo/pages/statistics/index/month.vue?macro=true";
import { default as alltime5u5yoAX6O0bjmI_45e49Qve5qLhcVC7ftAjLuVvZSuIWoMeta } from "/opt/build/repo/pages/statistics/index/alltime.vue?macro=true";
import { default as indexRtjX_X_45_FXqjajKcsXKypNfKoeBik5S_QkOzJYPJHmUMeta } from "/opt/build/repo/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46name_93OTWxPpHY3PMX3UdtFxd9LmXiwTsF6EHd1U8IilwWb7UMeta } from "/opt/build/repo/pages/t/[id]/[...name].vue?macro=true";
import { default as _91id_93K1JGMcHbVAfuuxYtinEcq9waQsyOlZalgiMO9U67WbcMeta } from "/opt/build/repo/pages/livelocation/[id].vue?macro=true";
import { default as editzk8GaKxapJ4a9vrD_45a7OjDuQdY7HwIZY_nGrkmAaBlMMeta } from "/opt/build/repo/pages/helmets/[id]/index/edit.vue?macro=true";
import { default as index0ibgzIrYLneVFrbk2qT6icLljc3ZM5HcYnxzqJO7VQgMeta } from "/opt/build/repo/pages/helmets/[id]/index.vue?macro=true";
import { default as index4LZoKX1GkVNg9XBDJYB23QN56R27hUQ27NHnw69kjQYMeta } from "/opt/build/repo/pages/routePlanner/index.vue?macro=true";
import { default as rewind_45debugyFUmpuNaE_45N1vmQe9J2vf0Q5JDggvzhbwWq0isznmoAMeta } from "/opt/build/repo/pages/t/[id]/rewind-debug.vue?macro=true";
import { default as editqutxuzGclW2hy2kelTRlzfzO28KzsVWKSGfNSX6z8SAMeta } from "/opt/build/repo/pages/intercoms/[id]/index/edit.vue?macro=true";
import { default as indexMFpaepJPoCHGJobiuiiAdd69Y3XXnKP3CK1YynXX4YQMeta } from "/opt/build/repo/pages/intercoms/[id]/index.vue?macro=true";
import { default as _91token_93Av_45Bko_0L_45kywllDa3_45U697VCjlxt1VbsaVYJwJSRogMeta } from "/opt/build/repo/pages/set_password/[token].vue?macro=true";
import { default as rewind_45rendererWqlo8D_01V_45FopBGJgxp415m3JT5extU2kHEjUMyk0MMeta } from "/opt/build/repo/pages/t/[id]/rewind-renderer.vue?macro=true";
import { default as _91token_93Q0IPUoYcXb1L_45IBQRDR6wC_45jaybbxT6gP4bBSm70E5kMeta } from "/opt/build/repo/pages/verify_email/[userid]/[token].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/search.vue")
  },
  {
    name: "referral",
    path: "/referral",
    component: () => import("/opt/build/repo/pages/referral.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: { ...(settingsYa9S1YcDD9UMaj5ELJs67gQjD0lYJ2UoIw9mzh67w2cMeta || {}), ...{"middleware":["nav-guard"]} },
    component: () => import("/opt/build/repo/pages/settings.vue")
  },
  {
    name: "webviews",
    path: "/webviews",
    component: () => import("/opt/build/repo/pages/webviews.vue"),
    children: [
  {
    name: groupsbH3NeRYdxElGdBW0booMFIhfGc65CrwbJWpxrnJ_45weoMeta?.name,
    path: "groups",
    component: () => import("/opt/build/repo/pages/webviews/groups.vue"),
    children: [
  {
    name: _91id_93kR9PFFVB350l_45TM_451wH5dHXZCS7YbQZB0e_452WKm0J7QMeta?.name,
    path: ":id()",
    meta: { ...(_91id_93kR9PFFVB350l_45TM_451wH5dHXZCS7YbQZB0e_452WKm0J7QMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/webviews/groups/[id].vue"),
    children: [
  {
    name: "webviews-groups-id-admin",
    path: "admin",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/admin.vue")
  },
  {
    name: "webviews-groups-id",
    path: "",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/index.vue")
  },
  {
    name: "webviews-groups-id-share",
    path: "share",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/share.vue")
  },
  {
    name: "webviews-groups-id-stats",
    path: "stats",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/stats.vue")
  },
  {
    name: "webviews-groups-id-members",
    path: "members",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/members.vue")
  },
  {
    name: "webviews-groups-id-posts",
    path: "posts",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/posts/index.vue")
  },
  {
    name: "webviews-groups-id-posts-postId",
    path: "posts/:postId()",
    component: () => import("/opt/build/repo/pages/webviews/groups/[id]/posts/[postId].vue")
  }
]
  },
  {
    name: "webviews-groups",
    path: "",
    meta: { ...(index_45ZTTVrRfOg4vXR15O13zal_45yXMiulsW5t3CS32Md4wUMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/webviews/groups/index.vue")
  },
  {
    name: "webviews-groups-search",
    path: "search",
    meta: { ...(searchxCpL7apWqsl6aCXeto93mq_nZZ40b_45zYDh_D6Gg7efIMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/webviews/groups/search.vue")
  }
]
  },
  {
    name: "webviews-challenges-id",
    path: "challenges/:id()",
    meta: { ...(_91id_93mRPYmzSE_45oXG0kMKsexPcZSRv1gee59oRJrAaAkWuYoMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/webviews/challenges/[id].vue"),
    children: [
  {
    name: "webviews-challenges-id-rankings",
    path: "rankings",
    meta: { ...(rankingsqP6lpk3Jy6WFbkTirK2_45oTQoZ8vGLkzRF1gt347jRkAMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/webviews/challenges/[id]/rankings.vue")
  }
]
  },
  {
    name: "webviews-bonus-club",
    path: "bonus-club",
    meta: { ...(indexNuqrJUlM1HQc8_DJFHk_45syD09zKXE_45tAfGHonjZT2MoMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/webviews/bonus-club/index.vue")
  }
]
  },
  {
    name: _91id_930PY3yfhGcnlHRRutsbxWXx7q8_45WR2ze8QJCOZiQ6GckMeta?.name,
    path: "/user/:id()",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id].vue"),
    children: [
  {
    name: "user-id",
    path: "",
    meta: indexZxReMgQKcLQzvh7hRk_45FUHdvASCsiMOPa9AoMnyrJnoMeta || {},
    component: () => import("/opt/build/repo/pages/user/[id]/index.vue")
  },
  {
    name: "user-id-photos",
    path: "photos",
    component: () => import("/opt/build/repo/pages/user/[id]/photos.vue")
  },
  {
    name: "user-id-blocked",
    path: "blocked",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/blocked.vue")
  },
  {
    name: "user-id-followers",
    path: "followers",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/followers.vue")
  },
  {
    name: "user-id-following",
    path: "following",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/following.vue")
  },
  {
    name: "user-id-garage",
    path: "garage",
    meta: indexCvKEGBcvSWyX93HRcnaDd0O4o_pRYTwnQXvp2z4zC_8Meta || {},
    component: () => import("/opt/build/repo/pages/user/[id]/garage/index.vue")
  },
  {
    name: "user-id-groups",
    path: "groups",
    component: () => import("/opt/build/repo/pages/user/[id]/groups/index.vue")
  },
  {
    name: "user-id-getaways",
    path: "getaways",
    component: () => import("/opt/build/repo/pages/user/[id]/getaways/index.vue"),
    children: [
  {
    name: "user-id-getaways-index-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/user/[id]/getaways/index/new.vue")
  }
]
  },
  {
    name: indexVE5_45t0PJA_aQBLPxptaqiVYQTdvxRl14mdnUSSb6O3sMeta?.name,
    path: "roadbook",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/roadbook/index.vue"),
    children: [
  {
    name: "user-id-roadbook-index",
    path: "",
    component: () => import("/opt/build/repo/pages/user/[id]/roadbook/index/index.vue")
  },
  {
    name: "user-id-roadbook-index-trips",
    path: "trips",
    component: () => import("/opt/build/repo/pages/user/[id]/roadbook/index/trips.vue")
  },
  {
    name: "user-id-roadbook-index-planned",
    path: "planned",
    component: () => import("/opt/build/repo/pages/user/[id]/roadbook/index/planned.vue")
  },
  {
    name: "user-id-roadbook-index-sections",
    path: "sections",
    component: () => import("/opt/build/repo/pages/user/[id]/roadbook/index/sections.vue")
  }
]
  },
  {
    name: "user-id-timeline",
    path: "timeline",
    component: () => import("/opt/build/repo/pages/user/[id]/timeline/index.vue"),
    children: [
  {
    name: "user-id-timeline-index-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/user/[id]/timeline/index/edit.vue")
  }
]
  },
  {
    name: "user-id-follow-requests",
    path: "follow-requests",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/follow-requests.vue")
  },
  {
    name: "user-id-achievements",
    path: "achievements",
    component: () => import("/opt/build/repo/pages/user/[id]/achievements/index.vue"),
    children: [
  {
    name: "user-id-achievements-index-achievementID",
    path: ":achievementID()",
    component: () => import("/opt/build/repo/pages/user/[id]/achievements/index/[achievementID].vue")
  }
]
  },
  {
    name: "user-id-garage-bikes",
    path: "garage/bikes",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/garage/bikes/index.vue"),
    children: [
  {
    name: "user-id-garage-bikes-index-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/user/[id]/garage/bikes/index/new.vue")
  }
]
  },
  {
    name: "user-id-garage-helmets",
    path: "garage/helmets",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/garage/helmets/index.vue"),
    children: [
  {
    name: "user-id-garage-helmets-index-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/user/[id]/garage/helmets/index/new.vue")
  }
]
  },
  {
    name: "user-id-garage-intercoms",
    path: "garage/intercoms",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/[id]/garage/intercoms/index.vue"),
    children: [
  {
    name: "user-id-garage-intercoms-index-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/user/[id]/garage/intercoms/index/new.vue")
  }
]
  }
]
  },
  {
    name: "feed",
    path: "/feed",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/feed/index.vue")
  },
  {
    name: getstartedfIUuxqZxfRCgjINwl9Nsdbqv_45hUGG0Dvlw5DBehjwz4Meta?.name,
    path: "/getstarted",
    meta: getstartedfIUuxqZxfRCgjINwl9Nsdbqv_45hUGG0Dvlw5DBehjwz4Meta || {},
    component: () => import("/opt/build/repo/pages/getstarted.vue"),
    children: [
  {
    name: "getstarted-email",
    path: "email",
    component: () => import("/opt/build/repo/pages/getstarted/email.vue")
  },
  {
    name: "getstarted",
    path: "",
    component: () => import("/opt/build/repo/pages/getstarted/index.vue")
  },
  {
    name: "getstarted-google",
    path: "google",
    component: () => import("/opt/build/repo/pages/getstarted/google.vue")
  },
  {
    name: "getstarted-onboarding",
    path: "onboarding",
    meta: onboardingxCpjxPsCtT6StgwdqzokmnZqxyb6z1HpaxNg3QYaPfoMeta || {},
    component: () => import("/opt/build/repo/pages/getstarted/onboarding.vue")
  },
  {
    name: "getstarted-forgot-password",
    path: "forgot-password",
    component: () => import("/opt/build/repo/pages/getstarted/forgot-password.vue")
  },
  {
    name: "getstarted-complete-profile",
    path: "complete-profile",
    component: () => import("/opt/build/repo/pages/getstarted/complete-profile.vue")
  }
]
  },
  {
    name: "pro-code",
    path: "/pro/:code()",
    meta: _91code_93vXoE22mu3C1NC9iap6YdoBd4NQlkwrEqbaG3C02GiaEMeta || {},
    component: () => import("/opt/build/repo/pages/pro/[code].vue")
  },
  {
    name: "trips-id",
    path: "/trips/:id()",
    component: () => import("/opt/build/repo/pages/trips/[id].vue"),
    children: [
  {
    name: "trips-id-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/trips/[id]/edit.vue")
  },
  {
    name: "trips-id-share",
    path: "share",
    component: () => import("/opt/build/repo/pages/trips/[id]/share.vue")
  },
  {
    name: "trips-id-photos",
    path: "photos",
    component: () => import("/opt/build/repo/pages/trips/[id]/photos.vue")
  },
  {
    name: "trips-id-participants",
    path: "participants",
    component: () => import("/opt/build/repo/pages/trips/[id]/participants.vue")
  },
  {
    name: "trips-id-rewind-video",
    path: "rewind-video",
    component: () => import("/opt/build/repo/pages/trips/[id]/rewind-video.vue")
  }
]
  },
  {
    name: "user",
    path: "/user",
    meta: {"middleware":["app-check","nav-guard"]},
    component: () => import("/opt/build/repo/pages/user/index.vue")
  },
  {
    name: _91id_93wLna3G_45SbajrwdB2bVOVWuqeOehy1m4FHRAduUy0AXwMeta?.name,
    path: "/groups/:id()",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/groups/[id].vue"),
    children: [
  {
    name: "groups-id-admin",
    path: "admin",
    component: () => import("/opt/build/repo/pages/groups/[id]/admin.vue")
  },
  {
    name: "groups-id",
    path: "",
    meta: indexIg3Kpx_45cusbR8ojziPuRoq8o9wNeNKjZaw1juPR12yEMeta || {},
    component: () => import("/opt/build/repo/pages/groups/[id]/index.vue")
  },
  {
    name: "groups-id-stats",
    path: "stats",
    component: () => import("/opt/build/repo/pages/groups/[id]/stats.vue")
  },
  {
    name: "groups-id-trips",
    path: "trips",
    meta: tripsQhLJmG_xv8sXiAXnMwWSNNIVmaGuLEw80welNooAq2kMeta || {},
    component: () => import("/opt/build/repo/pages/groups/[id]/trips.vue")
  },
  {
    name: "groups-id-members",
    path: "members",
    component: () => import("/opt/build/repo/pages/groups/[id]/members.vue")
  },
  {
    name: "groups-id-posts",
    path: "posts",
    component: () => import("/opt/build/repo/pages/groups/[id]/posts/index.vue")
  },
  {
    name: "groups-id-posts-postId",
    path: "posts/:postId()",
    component: () => import("/opt/build/repo/pages/groups/[id]/posts/[postId].vue")
  }
]
  },
  {
    name: "sentry-test",
    path: "/sentry-test",
    component: () => import("/opt/build/repo/pages/sentry-test.vue")
  },
  {
    name: "garage-bikes",
    path: "/garage/bikes",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/garage/bikes.vue")
  },
  {
    name: "garage",
    path: "/garage",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/garage/index.vue")
  },
  {
    name: "groups",
    path: "/groups",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/groups/index.vue"),
    children: [
  {
    name: "groups-index-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/groups/index/new.vue")
  }
]
  },
  {
    name: _91id_93tella6_M5NXkkGpZXk0CWwd5bdO4j0TZTGxL8Sa4PesMeta?.name,
    path: "/getaways/:id()",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/getaways/[id].vue"),
    children: [
  {
    name: "getaways-id",
    path: "",
    meta: index5CeMlm7Zv0Gmaz2jg7_6Z8EbzZ507gF_CfS5WsiMwt0Meta || {},
    component: () => import("/opt/build/repo/pages/getaways/[id]/index.vue")
  },
  {
    name: "getaways-id-details",
    path: "details",
    component: () => import("/opt/build/repo/pages/getaways/[id]/details.vue"),
    children: [
  {
    name: "getaways-id-details-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/getaways/[id]/details/edit.vue")
  },
  {
    name: "getaways-id-details-invite",
    path: "invite",
    component: () => import("/opt/build/repo/pages/getaways/[id]/details/invite.vue")
  }
]
  },
  {
    name: "getaways-id-members",
    path: "members",
    component: () => import("/opt/build/repo/pages/getaways/[id]/members.vue")
  },
  {
    name: "getaways-id-comments",
    path: "comments",
    component: () => import("/opt/build/repo/pages/getaways/[id]/comments.vue")
  }
]
  },
  {
    name: "postings-id",
    path: "/postings/:id()",
    component: () => import("/opt/build/repo/pages/postings/[id].vue"),
    children: [
  {
    name: "postings-id-report",
    path: "report",
    component: () => import("/opt/build/repo/pages/postings/[id]/report.vue")
  },
  {
    name: "postings-id-comments-comment_id-report",
    path: "comments/:comment_id()/report",
    component: () => import("/opt/build/repo/pages/postings/[id]/comments/[comment_id]/report.vue")
  }
]
  },
  {
    name: "sections-id",
    path: "/sections/:id()",
    component: () => import("/opt/build/repo/pages/sections/[id].vue")
  },
  {
    name: "t-id-rewind",
    path: "/t/:id()/rewind",
    meta: { ...(rewind_45j3Ny_45vsC28rswvbhH5YzfP9r9tN_45AC_IO6s2VQZ1wsMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/t/[id]/rewind.vue")
  },
  {
    name: "upgrade",
    path: "/upgrade",
    meta: { ...(indexMbHAtJ5Ql0WYvcFssfe12hzXsWpUjPJh4nFxfw0l62kMeta || {}), ...{"middleware":["nav-guard"]} },
    component: () => import("/opt/build/repo/pages/upgrade/index.vue")
  },
  {
    name: "challenge-id",
    path: "/challenge/:id()",
    meta: {"middleware":["app-check"]},
    component: () => import("/opt/build/repo/pages/challenge/[id].vue")
  },
  {
    name: "garage-helmets",
    path: "/garage/helmets",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/garage/helmets.vue")
  },
  {
    name: "voucher-code",
    path: "/voucher/:code()",
    meta: _91code_93JeVe4C8JGQXm7txYoVn1IxV13aXVY1Et_WrJn940_oYMeta || {},
    component: () => import("/opt/build/repo/pages/voucher/[code].vue")
  },
  {
    name: "bonusclub",
    path: "/bonusclub",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/bonusclub/index.vue")
  },
  {
    name: "groups-discover",
    path: "/groups/discover",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/groups/discover.vue")
  },
  {
    name: "upgrade-success",
    path: "/upgrade/success",
    meta: { ...(successcFZiG6D4gYzN2oT1xbVlq0_7rIT_45itqfchLW_mbYdQkMeta || {}), ...{"middleware":["nav-guard"]} },
    component: () => import("/opt/build/repo/pages/upgrade/success.vue")
  },
  {
    name: "bikes-id",
    path: "/bikes/:id()",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/bikes/[id]/index.vue"),
    children: [
  {
    name: "bikes-id-index-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/bikes/[id]/index/edit.vue")
  },
  {
    name: "bikes-id-index-service",
    path: "service",
    component: () => import("/opt/build/repo/pages/bikes/[id]/index/service.vue")
  }
]
  },
  {
    name: "challenges",
    path: "/challenges",
    meta: indexNmbYAUb0qnynAMnTt2Dfo4J8YkisMZURbLNl9OSl6s8Meta || {},
    component: () => import("/opt/build/repo/pages/challenges/index.vue"),
    children: [
  {
    name: "challenges-index-past",
    path: "past",
    component: () => import("/opt/build/repo/pages/challenges/index/past.vue")
  },
  {
    name: "challenges-index-current",
    path: "current",
    component: () => import("/opt/build/repo/pages/challenges/index/current.vue")
  },
  {
    name: "challenges-index-upcoming",
    path: "upcoming",
    component: () => import("/opt/build/repo/pages/challenges/index/upcoming.vue")
  }
]
  },
  {
    name: "garage-intercoms",
    path: "/garage/intercoms",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/garage/intercoms.vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexRtjX_X_45_FXqjajKcsXKypNfKoeBik5S_QkOzJYPJHmUMeta || {},
    component: () => import("/opt/build/repo/pages/statistics/index.vue"),
    children: [
  {
    name: "statistics-index-week",
    path: "week",
    component: () => import("/opt/build/repo/pages/statistics/index/week.vue")
  },
  {
    name: "statistics-index-year",
    path: "year",
    component: () => import("/opt/build/repo/pages/statistics/index/year.vue")
  },
  {
    name: "statistics-index-month",
    path: "month",
    component: () => import("/opt/build/repo/pages/statistics/index/month.vue")
  },
  {
    name: "statistics-index-alltime",
    path: "alltime",
    component: () => import("/opt/build/repo/pages/statistics/index/alltime.vue")
  }
]
  },
  {
    name: "t-id-name",
    path: "/t/:id()/:name(.*)*",
    component: () => import("/opt/build/repo/pages/t/[id]/[...name].vue")
  },
  {
    name: "livelocation-id",
    path: "/livelocation/:id()",
    meta: _91id_93K1JGMcHbVAfuuxYtinEcq9waQsyOlZalgiMO9U67WbcMeta || {},
    component: () => import("/opt/build/repo/pages/livelocation/[id].vue")
  },
  {
    name: "helmets-id",
    path: "/helmets/:id()",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/helmets/[id]/index.vue"),
    children: [
  {
    name: "helmets-id-index-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/helmets/[id]/index/edit.vue")
  }
]
  },
  {
    name: "routePlanner",
    path: "/routePlanner",
    meta: index4LZoKX1GkVNg9XBDJYB23QN56R27hUQ27NHnw69kjQYMeta || {},
    component: () => import("/opt/build/repo/pages/routePlanner/index.vue")
  },
  {
    name: "t-id-rewind-debug",
    path: "/t/:id()/rewind-debug",
    meta: { ...(rewind_45debugyFUmpuNaE_45N1vmQe9J2vf0Q5JDggvzhbwWq0isznmoAMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/t/[id]/rewind-debug.vue")
  },
  {
    name: "intercoms-id",
    path: "/intercoms/:id()",
    meta: {"middleware":["nav-guard"]},
    component: () => import("/opt/build/repo/pages/intercoms/[id]/index.vue"),
    children: [
  {
    name: "intercoms-id-index-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/intercoms/[id]/index/edit.vue")
  }
]
  },
  {
    name: "set_password-token",
    path: "/set_password/:token()",
    component: () => import("/opt/build/repo/pages/set_password/[token].vue")
  },
  {
    name: "t-id-rewind-renderer",
    path: "/t/:id()/rewind-renderer",
    meta: { ...(rewind_45rendererWqlo8D_01V_45FopBGJgxp415m3JT5extU2kHEjUMyk0MMeta || {}), ...{"middleware":["app-check"]} },
    component: () => import("/opt/build/repo/pages/t/[id]/rewind-renderer.vue")
  },
  {
    name: "verify_email-userid-token",
    path: "/verify_email/:userid()/:token()",
    meta: _91token_93Q0IPUoYcXb1L_45IBQRDR6wC_45jaybbxT6gP4bBSm70E5kMeta || {},
    component: () => import("/opt/build/repo/pages/verify_email/[userid]/[token].vue")
  }
]